import axios from 'axios';
import { generateformData } from './form';

export default function ajaxSubmit(formName, subject, values) {
  let formValues = {
    'form-name': formName,
    ...values,
  };

  if (subject) {
    formValues = {
      ...formValues,
      subject,
    };
  }

  const data = generateformData(formValues);

  return axios({
    method: 'post',
    url: '',
    headers: { 'content-type': 'multipart/form-data' },
    data,
  });
}
